export default __webpack_public_path__ + "static/media/12.9aa9b42f.png";